export default "__VITE_ASSET__5bebf548__"